module.exports = __webpack_public_path__ + "media/images/teams/logo__1-7f5ddf43d4959095fd4cb937ee51883f.svg";